export enum USER_ROLE {
	ADMIN = 'ADMIN',
	REALTOR = 'REALTOR',
    CLIENT = 'CLIENT'
}

export enum USER_ROLE_TO_STATUS {
	ADMIN = 'adminStatus',
	REALTOR = 'realtorStatus',
    CLIENT = 'clientStatus'
}